export default (params) => {
    const tourCriteria = {};
    const element = params.warranted;
    if (element) {
        tourCriteria.warranted = true;
    }

    return tourCriteria;
};